import { SignInWithOtpErrorCodes } from '@local/typedefs/dist/common/errorCodes/outbound';
import { SignInWithOtpErrorMessages, SOMETHING_WENT_WRONG, } from '@/constants/errorMessages';
export const getErrorMessage = (code) => {
    switch (code) {
        case SignInWithOtpErrorCodes.INCORRECT_OTP:
            return SignInWithOtpErrorMessages.INCORRECT_OTP;
        default:
            return SOMETHING_WENT_WRONG;
    }
};
